import React from "react";
import "./posting.scss";

const Posting = () => (
  <div className="PostingContainer">
    <div className="Posting">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" id="upload" height="120" width="120">
        <defs>
          <style>
            {`
              .a { fill: #f7f7f7; }
              .b { fill: #e1e5ff; }
              .c { fill: #79b17d; }
              .d { fill: #fff; }
              .e { fill: #8cb4d6; }
            `}
          </style>
        </defs>

        <g className="background" data-animator-group="true" data-animator-type="2">
          <circle className="a" cx="19.9" cy="19.9" r="19.9" />
        </g>

        <polygon className="b progress" points="29.34 15 23.91 9.07 23.91 15 29.34 15" />

        <path className="c" d="M24.06,8.19H13.76A2.85,2.85,0,0,0,10.89,11V29a2.85,2.85,0,0,0,2.87,2.82H27.11A2.85,2.85,0,0,0,30,29V14.69Zm.21,1.38,4.45,4.88H24.27Z" />

        <path className="d" d="M29.2,29A2.08,2.08,0,0,1,27.11,31H13.76A2.08,2.08,0,0,1,11.67,29V11A2.08,2.08,0,0,1,13.76,9h9.73v6.26H29.2Z" />

        <g className="arrow" data-animator-group="true" data-animator-type="0">
          <path className="c" d="M23.32,17.5a4.06,4.06,0,1,0,0,5.74,4,4,0,0,0,0-5.74Zm-2.87,5.82a.64.64,0,0,1-.64-.64V19.6l-.76.76a.64.64,0,0,1-.91-.91L20,17.6l.1-.08,0,0,.06,0,.07,0,.05,0h.25l.06,0,.06,0,.07,0,0,0,.1.08,1.85,1.85a.64.64,0,0,1-.91.91l-.76-.76v3.09a.64.64,0,0,1-.64.64Z" />
        </g>

        <g className="progressLoader" data-animator-group="true" data-animator-type="2">
          <polygon className="e" points="15 28 15 27 26 27 26 28 15 28" />
        </g>
      </svg>
    </div>
    <h3>
      Your story is being uploaded and sent to admins for review.
      Please don&apos;t close out of this tab or browser before it finishes.
    </h3>
  </div>
);

export default Posting;
